var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlayIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 45,
  height: 44,
  viewBox: "0 0 45 44",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M31.6097 21.9999L18.6328 12.1172V31.8826L31.6097 21.9999ZM44.5 22C44.5 28.072 42.3519 33.2577 38.0556 37.554C33.7577 41.8518 28.572 44 22.5 44C16.428 44 11.2423 41.8518 6.946 37.554C2.64814 33.2577 0.5 28.072 0.5 22C0.5 15.928 2.64814 10.7423 6.946 6.446C11.2423 2.14814 16.428 0 22.5 0C28.572 0 33.7577 2.14814 38.0556 6.446C42.3519 10.7423 44.5 15.928 44.5 22Z",
  fill: "#4585FF"
})));
export default SvgPlayIcon;